import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { dispatchResizeEvent } from 'helpers/window';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';

class ModalAccountTermsAndPrivacyPolicy extends React.Component {
  componentDidUpdate = prevProps => {
    const { cmsPageTermsOfService, cmsPagePrivacyPolicy } = this.props;

    if (
      !cmsPageTermsOfService.pending &&
      !cmsPagePrivacyPolicy.pending &&
      (prevProps.cmsPageTermsOfService.pending || prevProps.cmsPagePrivacyPolicy.pending)
    ) {
      dispatchResizeEvent();
    }
  };

  render() {
    const {
      intl: { messages },
      show,
      cmsPageTermsOfService,
      cmsPagePrivacyPolicy,
      formStatus,
    } = this.props;

    return (
      <Modal show={show} bsSize="lg" class="full-width">
        <Modal.Header>
          <Modal.Title>
            {messages.terms_of_service} / {messages.privacy_policy}
          </Modal.Title>
        </Modal.Header>
        {show && (
          <Modal.Body>
            {!cmsPageTermsOfService.data.id && (
              <Data
                dataName="cmsSystemPageTermsOfService"
                url="/api/pages/termsofservice.json"
                data={cmsPageTermsOfService}
              />
            )}

            {!cmsPagePrivacyPolicy.data.id && (
              <Data
                dataName="cmsSystemPagePrivacyPolicy"
                url="/api/pages/privacypolicy.json"
                data={cmsPagePrivacyPolicy}
              />
            )}

            <div class="themed">
              {cmsPageTermsOfService.pending || cmsPagePrivacyPolicy.pending ? (
                <Loader />
              ) : (
                <div>
                  <p>{messages.accept_terms_before_continuing}</p>

                  <CmsPage data={cmsPageTermsOfService.data} doUpdateActiveCms={false} doUpdateDocMeta={false} />
                  <CmsPage data={cmsPagePrivacyPolicy.data} doUpdateActiveCms={false} doUpdateDocMeta={false} />

                  <div class="m-t-20 text-right">
                    <Button bsStyle="primary" bsSize="lg" disabled={formStatus.pending} onClick={this.props.onSubmit}>
                      {formStatus.pending ? <i class="fa fa-circle-notch fa-spin" /> : null} {messages.i_accept}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    cmsPageTermsOfService: state.data.cmsSystemPageTermsOfService,
    cmsPagePrivacyPolicy: state.data.cmsSystemPagePrivacyPolicy,
    formStatus: state.formStatus.clientAcceptTerms,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: () => {
      formStatusDispatchHelper('clientAcceptTerms', '/api/clientacceptterms.json', {}, 'post', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ModalAccountTermsAndPrivacyPolicy)
  )
);
